<template>
  <b-card bg-variant="dark" text-variant="white" class="shadow">
    <b-row align-v="center">
      <b-col>
        <slot>
          <h6 class="card-title text-uppercase _mt-07">
            {{ title }}
          </h6>
        </slot>
      </b-col>

      <b-col cols="auto" class="_mt-05">
        <slot name="icon">
          <span class="p-3 card-main">
          <i :class="icon" class="h5"></i>
          </span>
        </slot>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
export default {
  name: "stats-card",
  props: {
    icon: String,
    title: String,
  },
};
</script>
<style>
._mt-07 {
  margin-top: 0.7rem;
}
._mt-05 {
  margin-top: 5px;
}

.card-main {
  background: linear-gradient(87deg,#476072,#548CA8);
  border-radius: 10%;
  box-shadow: 0 0 2rem 0 rgba(136,152,170,.15)!important;
}

</style>



// WEBPACK FOOTER //
// src/components/cards/StatsCard.vue